export default __webpack_public_path__ + "605cbb4567e2b4dbd4fc153f1954c68e.svg";